export const tasksAssignmentKeys = {
  all: ['tasks-assignments'] as const,
  lists: () => [...tasksAssignmentKeys.all, 'list'] as const,
  list: (workspaceId?: number | null) => [...tasksAssignmentKeys.lists(), workspaceId ?? null] as const,
  incompleteCount: (workspaceId?: number | null) =>
    [...tasksAssignmentKeys.all, 'incomplete-count', workspaceId ?? null] as const,
}
